import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import RestService from '../rest.service';
import CacheService from '@components/collection/components/globals/backend-services/cache.service';
var CMS_MENU_URL = 'api/v2/customerfacing/cms/menu/search';

var CmsMenus = /*#__PURE__*/function () {
  function CmsMenus() {
    _classCallCheck(this, CmsMenus);
  }

  _createClass(CmsMenus, [{
    key: "getMenus",
    value: function getMenus(locale) {
      return new Promise(function (resolve, reject) {
        CacheService.cacheRequest("".concat(CMS_MENU_URL, "?locale=").concat(locale), function () {
          return RestService.request("".concat(CMS_MENU_URL, "?locale=").concat(locale), {
            method: "GET"
          }, true);
        }).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }]);

  return CmsMenus;
}();

export default new CmsMenus();